export function findMostRecentDate(array) {
  let mostRecent = null

  array.forEach(obj => {
    ['created_at', 'regenerated_at'].forEach(key => {
      if (obj[key]) {
        const date = new Date(obj[key])
        if (!mostRecent || date > mostRecent) {
          mostRecent = date
        }
      }
    })
  })

  return mostRecent
}